module.exports = __webpack_public_path__ + "img/logo-proxpect.a2483070.svg";